import * as React from 'react';
import { Button } from '../Button';
import { ModalWindow } from '../ModalWindow';
import { Spinner, SpinnerSize } from '../Spinner';
import { Icon, IconSize, IconType } from '../Icon';
import styled from 'styled-components';
import { Grid } from '../Grid';

export interface ISaveDialogProps {
  /** Show or not an error message. String but treat like boolean. */
  errorMessage?: string;
  /** @deprecated not used. */
  className?: string;
  /** Show save spinner. */
  showSaveSpinner: boolean;
  /** Show save success icon. */
  showSaveSuccess: boolean;
  /** React CSS Properties. */
  style?: React.CSSProperties;
  /** A callback triggered when user clicked 'Yes' button. */
  onYesClick: () => void;
  /** A callback triggered when user clicked 'No' button. */
  onNoClick: () => void;
}

const StyledSaveDialog = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  * {
    margin: 0 ${(props) => props.theme.spacing.spacing4};
  }
`;

/**
 * Modal window with pre-formatted text announcing the user about saving data.
 */
export class SaveDialog extends React.Component<ISaveDialogProps, {}> {
  public static defaultProps: Partial<ISaveDialogProps> = {};

  public render() {
    return (
      <ModalWindow uitype={'fit'} onClose={this.doOnNoClick}>
        <Grid>
          <h3>
            {this.props.errorMessage
              ? 'There was a problem saving your changes. Do you want to try again?'
              : 'Do you want to save changes?'}
          </h3>

          <StyledSaveDialog>
            {this.props.showSaveSuccess ? <Icon type={IconType.Check} size={IconSize.Small} /> : null}
            {this.props.showSaveSpinner ? <Spinner size={SpinnerSize.small} className={'save-dialog--icon'} /> : null}
            <Button intent={'primary'} id={'save-dialog-button'} onClick={this.props.onYesClick}>
              {this.props.errorMessage ? 'Try again' : 'Yes'}
            </Button>
            <Button intent={'secondary'} className={'save-changes--button'} onClick={this.doOnNoClick}>
              No
            </Button>
          </StyledSaveDialog>
        </Grid>
      </ModalWindow>
    );
  }

  private doOnNoClick = () => {
    if (!this.props.showSaveSpinner) {
      this.props.onNoClick();
    }
  };
}
